/* eslint-disable no-undef */
/* eslint-disable no-console */
(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.factory('AccessoPayService', AccessoPayService);

	/**
	 * Our accessoPay service.
	 * @param {Service} $q $q
	 * @param {Service} $http $http
	 * @param {Service} $log $log
	 * @param {Service} $injector $injector
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $state $state
	 * @param {Service} $document $document
	 * @param {Service} $window $window
	 * @param {Service} $location $location
	 * @param {Service} $transitions The transition service
	 * @param {Service} bugsnag Bugsnag
	 * @param {Service} AppData AppData
	 * @param {Service} AccessoPayPaymentService AccessoPayPaymentService
	 * @param {Service} AccessoPayUtils AccessoPayUtils
	 * @param {Service} AnalyticsDataLayerService Analytics
	 * @param {Service} ApplePayPreloader ApplePayPreloader
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Embed Embed
	 * @param {Service} LegacyCart LegacyCart
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Language Language
	 * @param {Service} Logging Logging
	 * @param {Service} Modal Modal
	 * @param {Service} ProfileLoginSessionService ProfileLoginSessionService
	 * @param {Service} RouteRejectionService RouteRejectionService
	 * @param {Service} ShippingService ShippingService
	 * @param {Service} UserInfo UserInfo
	 * @param {Service} UrlUtils UrlUtils
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {AccessoPayService} The instance
	 * @ngInject
	 */
	function AccessoPayService(
		$q,
		$http,
		$log,
		$injector,
		$rootScope,
		$state,
		$document,
		$window,
		$location,
		$transitions,
		bugsnag,
		AppData,
		AccessoPayPaymentService,
		AccessoPayUtils,
		AnalyticsDataLayerService,
		ApplePayPreloader,
		CustomActionService,
		Embed,
		LegacyCart,
		Enums,
		JSONValidator,
		Language,
		Logging,
		Modal,
		ProfileLoginSessionService,
		RouteRejectionService,
		ShippingService,
		UserInfo,
		UrlUtils,
		Utilities,
		UtilsValidation
	) {
		var isFunction = angular.isFunction,
			currentRoute = 'delivery',
			currentRouteParam = '',
			isRealObject = UtilsValidation.isRealObject,
			getBoolean = Utilities.getBoolean,
			validString = UtilsValidation.validString,
			returnOrDefault = UtilsValidation.returnOrDefault,
			validObject = UtilsValidation.validObject,
			validArray = UtilsValidation.validArray,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getLocale = Language.getLocale,
			ERROR_PREFIX = '[AccessoPayService] ',
			authorizingRouteGuard,
			parentOriginUrl;

		var service = {
			_destroyAccessoPayInstance: _destroyAccessoPayInstance,
			_checkForApplePay: _checkForApplePay,
			_completeApplePayMerchantValidation: _completeApplePayMerchantValidation,
			_completeApplePayPayment: _completeApplePayPayment,
			_initiateParentApplePaySession: _initiateParentApplePaySession,
			_sendAccessoPayMessage: _sendAccessoPayMessage,
			_sendAnalyticsEvent: _sendAnalyticsEvent,
			_sendParentMessage: _sendParentMessage,

			clearQueryParams: clearQueryParams,
			createAccessoPayEvent: createAccessoPayEvent,
			getAccessoPayConfiguration: getAccessoPayConfiguration,
			getAccessoPayInstance: getAccessoPayInstance,
			getAppConfig: getAppConfig,
			getCurrentRoute: getCurrentRoute,
			getDeliveryMethods: getDeliveryMethods,
			getPaymentRedirectUrl: getPaymentRedirectUrl,
			getRedirectUrl: getRedirectUrl,
			getWindow: getWindow,
			mountAccessoPay: mountAccessoPay,
			onAuthorizing: onAuthorizing,
			onBillingDemographics: onBillingDemographics,
			onCancel: onCancel,
			onDeliveryComplete: onDeliveryComplete,
			onDonationDecline: onDonationDecline,
			onDonationSelect: onDonationSelect,
			onInsuranceDecline: onInsuranceDecline,
			onInsuranceSelect: onInsuranceSelect,
			onInitializeFailed: onInitializeFailed,
			onRouteChanged: onRouteChanged,
			setupAccessoPayEvents: setupAccessoPayEvents
		};

		return service;

		/**
		 * Leaves a bugsnag breadcrumb
		 * @param {String} msg The message
		 * @returns {undefined}
		 */
		function breadcrumb(msg) {
			if (checkProp('bugsnag.breadcrumb', bugsnag, angular.isFunction)) {
				bugsnag.breadcrumb('accesso Pay Service: ' + msg);
			}

			$http.post(AppData.getApiUrl() + '/api/log', {
				m: msg,
				s: checkProp('AppData.cart.session_id', AppData, 'returnValue'),
				t: 'accesso-pay-service-bread'
			});
		}

		/**
		 * Notify bugsnag
		 * @private
		 * @param {String} msg The message
		 * @returns {undefined}
		 */
		function notifyBugsnag(msg) {
			if (checkProp('bugsnag.notify', bugsnag, angular.isFunction)) {
				bugsnag.notify('accesso Pay Service: ' + msg);
			}

			$http.post(AppData.getApiUrl() + '/api/log', {
				m: msg,
				s: checkProp('AppData.cart.session_id', AppData, 'returnValue'),
				t: 'accesso-pay-service-notify'
			});
		}

		/**
		 * Returns the accesso pay configuration if any
		 * @public
		 * @memberof AccessoPayService
		 * @returns {Object} our accesso pay configuration
		 */
		function getAppConfig() {
			if (JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay)) {
				return JSON.parse(AppData.settings.accesso_pay);
			}
			return {};
		}

		/**
		 * Returns accesso Pay instance
		 * @public
		 * @memberof AccessoPayService
		 * @throws {Error} error if accessoPay is not on window
		 * @returns {Object} accesso Pay instance
		 */
		function getAccessoPayInstance() {
			var accessoPay = service.getWindow().accessoPay;

			if (isRealObject(accessoPay)) {
				return accessoPay;
			}

			throw new Error(ERROR_PREFIX + 'accessoPay sdk is not available');
		}

		/**
		 * Returns delivery methods to be passed
		 * @public
		 * @memberof AccessoPayService
		 * @throws {UnrecoverableException} routes to cart on error
		 * @returns {Object[]} delivery methods
		 */
		function getDeliveryMethods() {
			var accessoPayDeliveryMethods = [];
			var useShippingLocaleOverrides = JSONValidator.validate('shipping_locale_overrides', AppData.settings.shipping_locale_overrides);
			var shippingLocaleOverrides = useShippingLocaleOverrides ? JSON.parse(AppData.settings.shipping_locale_overrides) : {};
			var accessoShippingMethods,
				isNonPhysicalDeliveryMethod;
			try {
				accessoShippingMethods = ShippingService.getUpdatedShippingMethodsForCurrentCart() || [];
				isNonPhysicalDeliveryMethod = ShippingService.isNonPhysicalDeliveryMethod;

				accessoShippingMethods.forEach(function mapShoplandToAccessoPayDeliveryMethods(deliveryMethod) {
					var price = parseFloat(deliveryMethod.price),
						shippingMethodId = deliveryMethod.method;

					accessoPayDeliveryMethods.push({
						additionalInfo: useShippingLocaleOverrides ? ShippingService.getShippingMethodOverrideLocale(shippingMethodId, shippingLocaleOverrides, 'description') : ShippingService.getDeliveryDescriptionSummaryByType(shippingMethodId),
						allowedCountries: AccessoPayUtils.getAllowedDeliveryCountries(shippingMethodId),
						amount: price,
						collectAddress: !isNonPhysicalDeliveryMethod(shippingMethodId),
						description: useShippingLocaleOverrides ? ShippingService.getShippingMethodOverrideLocale(shippingMethodId, shippingLocaleOverrides, 'long_desc') : deliveryMethod.description,
						id: shippingMethodId,
						label: AccessoPayUtils.getLabelForDeliveryMethod(price, deliveryMethod.title)
					});
				});
				return accessoPayDeliveryMethods;
			} catch (err) {
				throw new RouteRejectionService.UnrecoverableException(Enums.routes.CART);
			}
		}

		/**
		 * Returns the url where we should be redirecting to for redirect payments
		 * @public
		 * @memberof AccessoPayService
		 * @param {String} parentUrl The parent url
		 * @returns {String} the redirect url
		 */
		function getRedirectUrl(parentUrl) {
			var win = service.getWindow();
			var config = service.getAppConfig();

			if (validString(config.redirectUrl)) {
				return config.redirectUrl;
			}

			if (parentUrl) {
				return parentUrl;
			}

			return 'https://' + win.location.host + '/accesso-pay';
		}

		/**
		 * Returns the payment redirect url.
		 * @public
		 * @memberof AccessoPayService
		 * @param {String} parentUrl The parent url if we are in an iframe
		 * @param {String} [accessToken] Optional access token for logged in TE2 guests
		 * @returns {String} The payment redirect url
		 */
		function getPaymentRedirectUrl(parentUrl, accessToken) {
			var paymentRedirectUrl = service.getRedirectUrl(parentUrl),
				search = $location.search(),
				queryParams = {},
				urlParameters = Enums.urlParameters,
				cart = AppData.cart,
				total = parseFloat(AppData.GetCartSummary.total);

			if (isNaN(total)) {
				$rootScope.routeTo(Enums.routes.CART);
				return;
			}

			/* eslint-disable camelcase */
			queryParams.cart_id = cart.cart_id;
			queryParams.cart_key = cart.cart_key;
			queryParams.session_id = cart.session_id;
			queryParams.guest_checkout = ProfileLoginSessionService.isGuestCheckout();
			queryParams.acsop_v5_pmt = '1';
			/* eslint-disable camelcase */

			if (search._m && paymentRedirectUrl.indexOf('_m=') < 0) {
				queryParams._m = Utilities.getMerchant().toLowerCase();
			}

			if (search._d === 'true' && paymentRedirectUrl.indexOf('_d=') < 0) {
				queryParams._d = 'true';
			}

			if (search.l && paymentRedirectUrl.indexOf('?l=') < 0 && paymentRedirectUrl.indexOf('&l=') < 0) {
				queryParams.l = search.l;
			}

			if (validString(accessToken)) {
				queryParams.access_token = accessToken;
			}

			Object.values(urlParameters).forEach(function appendParam(paramKey) {
				if (search[paramKey] && paymentRedirectUrl.indexOf(paramKey + '=') < 0) {
					queryParams[paramKey] = search[paramKey];
				}
			});

			//add other query params here for affiliates - emerchantid, merchantid

			return paymentRedirectUrl + (paymentRedirectUrl.indexOf('?') < 0 ? '?' : '&') + UrlUtils.objectToQueryParams(queryParams);
		}

		/**
		 * Returns the configuration object for accessoPay
		 * @public
		 * @memberof AccessoPayService
		 * @param {String} parentUrl The parent url
		 * @returns {Object} accessoPay configuration
		 */
		function getAccessoPayConfiguration(parentUrl) {
			var TE2Service = $injector.has('TE2Service') ? $injector.get('TE2Service') : {},
				te2Settings = angular.isFunction(TE2Service.getSettings) && TE2Service.getSettings(),
				accessToken = checkProp('te2Settings.te2Token', te2Settings, validString) ? te2Settings.te2Token : null,
				disabledCardTypes = AccessoPayUtils.getDisabledCardTypes(),
				disabledPaymentMethods = AccessoPayUtils.getDisabledPaymentMethods(),
				accessoPayconfigs = service.getAppConfig(),
				giftCardMaxEntries;

			var config = {
				amount: parseFloat(AccessoPayUtils.getAmountForPayment()),
				creditCard: {
					disableSave: getBoolean(accessoPayconfigs.disableSaveCreditCard),
					// always set this to true for v5
					requireDemographics: true,
					requireStoredCVV: JSONValidator.validate('stored_payments_cvv_capture', AppData.settings.stored_payments_cvv_capture)
				},
				cssVariables: getCssVariables(),
				currencyCode: AppData.currencyCode,
				delivery: {
					address: AccessoPayUtils.getUserShippingDemographics(),
					defaultSelectedId: '',
					options: service.getDeliveryMethods(),
					phoneNumberRequired: true
				},
				disablePayments: {
					cardBrandName: disabledCardTypes,
					paymentMethodName: disabledPaymentMethods
				},
				lineItems: AccessoPayUtils.getLineItems(),
				paymentRedirectUrl: service.getPaymentRedirectUrl(parentUrl, accessToken),
				recurring: AccessoPayUtils.hasScheduledPayments(),
				sessionId: AppData.cart.session_id,
				style: AccessoPayUtils.getStoreColors(),
				supportMultiplePayments: getBoolean(accessoPayconfigs.supportMultiplePayments),
				unifiedDesign: { useNewSpinner: true },
				user: AccessoPayUtils.getUserBillingDemographics()
			};

			// Does the payment configuration have a tesco promo code?
			if (angular.isDefined(accessoPayconfigs.tescoPromoCode)) {
				// Pass the Tesco Promo Code to accessoPay if it exists to handle the payment validation.
				config.tescoPromoCode = accessoPayconfigs.tescoPromoCode;
			};

			// Does the store have a stored value card configuration?
			if (JSONValidator.validate('stored_value_card', AppData.settings.stored_value_card)) {
				// Get the max number of entries
				giftCardMaxEntries = JSON.parse(AppData.settings.stored_value_card).maxPartialPaymentCount;

				// If the value is greater than 0, set the configuration to the aPay config
				if (giftCardMaxEntries > 0) {
					config.giftCard = {
						maxEntries: giftCardMaxEntries,
					};
				}
			}

			if (validString(parentUrl)) {
				config.originUrl = AccessoPayUtils.parseUrlOrigin(parentUrl);
			}

			config.parentUrl = $window.location.protocol + '//' + $window.location.host;

			if (validString(accessToken) && checkProp('te2Settings.TE2AccountInfo', te2Settings, validObject)) {
				config.user = angular.extend({}, config.user, {
					accessToken: accessToken,
					customerId: returnOrDefault(te2Settings.TE2AccountInfo.userID, '', validString),
					email: returnOrDefault(te2Settings.TE2AccountInfo.emailAddress, '', validString),
					firstName: returnOrDefault(te2Settings.TE2AccountInfo.firstName, '', validString),
					lastName: returnOrDefault(te2Settings.TE2AccountInfo.lastName, '', validString)
				});
			}
			return config;
		}

		/**
		 * Mounts accesso pay
		 * @public
		 * @memberof AccessoPayService
		 * @returns {AccessoPay} Return the accesso pay instance
		 */
		function mountAccessoPay() {
			Embed
				.getParentUrl()
				.then(function onParentOriginUrl(url) {
					var config = service.getAccessoPayConfiguration(url);
					var accessoPayInstance;

					try {
						accessoPayInstance = service.getAccessoPayInstance();
						if (isRealObject(accessoPayInstance)) {
							accessoPayInstance.destroy();
						}
					} catch (err) {
						// do nothing
					}

					service.setupAccessoPayEvents();

					if (config) {
						service.getAccessoPayInstance().mount('accesso-pay', config);
					}
				});
		}

		/**
		 * Setup accesso pay
		 * @public
		 * @memberof AccessoPayService
		 * @returns {undefined}
		 */
		function setupAccessoPayEvents() {
			var accessoPay = service.getAccessoPayInstance(),
				events = accessoPay.event,
				tenantDetails = AccessoPayUtils.getTenantDetails();

			accessoPay
				.setDebug(Logging.enabled)
				.configure(tenantDetails.tenantName, tenantDetails.merchantId, tenantDetails.sessionId, tenantDetails.language)
				.on(events.AUTHORIZING, service._sendAnalyticsEvent)
				.on(events.AUTHORIZING, service.onAuthorizing)
				// Always register the remove route guard before the actual event
				.on(events.CANCEL, removeAuthorizingRouteGuard)
				.on(events.CANCEL, service._sendAnalyticsEvent)
				.on(events.CANCEL, service.createAccessoPayEvent(service.onCancel))
				// Always register the remove route guard before the actual event
				.on(events.PAYMENT_REDIRECT, removeAuthorizingRouteGuard)
				.on(events.PAYMENT_REDIRECT, service._sendAnalyticsEvent)
				.on(events.PAYMENT_REDIRECT, service.createAccessoPayEvent(AccessoPayPaymentService.onPaymentRedirect))
				// Always register the remove route guard before the actual event
				.on(events.PAYMENT_COMPLETE, removeAuthorizingRouteGuard)
				.on(events.PAYMENT_COMPLETE, service._sendAnalyticsEvent)
				.on(events.PAYMENT_COMPLETE, service.createAccessoPayEvent(AccessoPayPaymentService.onPaymentComplete))
				// Always register the remove route guard before the actual event
				.on(events.PAYMENT_FAILED, removeAuthorizingRouteGuard)
				.on(events.PAYMENT_FAILED, service._sendAnalyticsEvent)
				.on(events.PAYMENT_FAILED, service.createAccessoPayEvent(AccessoPayPaymentService.onPaymentFailedOrCancelled))
				// Always register the remove route guard before the actual event
				.on(events.PAYMENT_CANCELLED, removeAuthorizingRouteGuard)
				.on(events.PAYMENT_CANCELLED, service._sendAnalyticsEvent)
				.on(events.PAYMENT_CANCELLED, service.createAccessoPayEvent(AccessoPayPaymentService.onPaymentFailedOrCancelled))
				.on(events.DELIVERY_INFO, service.createAccessoPayEvent(service.onDeliveryComplete))
				.on(events.PAYMENT_SELECTED, service.createAccessoPayEvent(AccessoPayPaymentService.onPaymentMethodSelected))
				.on(events.PAYMENT_SELECTED, service._sendAnalyticsEvent)
				.on(events.INITIALIZE_FAILED, service.createAccessoPayEvent(service.onInitializeFailed))
				.on(events.INITIALIZE_FAILED, service._sendAnalyticsEvent)
				.on(events.INITIALIZED, service.createAccessoPayEvent($rootScope.hideSpinner))
				.on(events.INITIALIZED, service._sendAnalyticsEvent)
				.on(events.ROUTE_CHANGE, service.createAccessoPayEvent(service.onRouteChanged))
				.on(events.ROUTE_CHANGE, service._sendAnalyticsEvent)
				.on(events.CLEAR_QUERY_PARAMS, service.createAccessoPayEvent(service.clearQueryParams))
				.on(events.APPLE_PAY_CHECK, service._checkForApplePay)
				.on(events.APPLEPAY_COMPLETE_MERCHANT_VALIDATION, service._completeApplePayMerchantValidation)
				.on(events.APPLEPAY_COMPLETE_PAYMENT, service._completeApplePayPayment)
				.on(events.APPLE_PAY_START_SESSION, service._initiateParentApplePaySession)
				.on(events.BILLING_DEMOGRAPHICS, service.createAccessoPayEvent(service.onBillingDemographics))
				.on(events.INSURANCE_SELECT, service.createAccessoPayEvent(service.onInsuranceSelect))
				.on(events.INSURANCE_SELECT, service._sendAnalyticsEvent)
				.on(events.INSURANCE_DECLINE, service.createAccessoPayEvent(service.onInsuranceDecline))
				.on(events.INSURANCE_DECLINE, service._sendAnalyticsEvent)
				.on(events.DONATION_SELECT, service.createAccessoPayEvent(service.onDonationSelect))
				.on(events.DONATION_SELECT, service._sendAnalyticsEvent)
				.on(events.DONATION_DECLINE, service.createAccessoPayEvent(service.onDonationDecline))
				.on(events.DONATION_DECLINE, service._sendAnalyticsEvent);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES, onDeliveryCartSummaryFailed);
		}

		/**
		 * Sends a message to AccessoPay iframe window
		 * @param {String} frameId AccessoPay's iframe element id
		 * @param {Object} eventType The message type
		 * @param {Object} eventPayload Payload to send accessoPay
		 * @returns {undefined}
		 */
		function _sendAccessoPayMessage(frameId, eventType, eventPayload) {
			var accessoPayIframe = $document[0].getElementById(frameId);
			var iframeOrigin = AccessoPayUtils.parseUrlOrigin(accessoPayIframe.src);
			var message = Object.assign({ type: eventType }, { payload: eventPayload || {} });

			if (!accessoPayIframe || !accessoPayIframe.contentWindow) {
			  return;
			}

			accessoPayIframe.contentWindow.postMessage(message, iframeOrigin);
		  }

		/**
		 * Sends a message to parent window
		 * @param {String} type Message type
		 * @param {Object} payload The message payload
		 * @returns {undefined}
		 */
		function _sendParentMessage(type, payload) {
			var message = Object.assign({ messageType: type || '' }, payload)
			$window.parent.postMessage(JSON.stringify(message), Embed.parentOriginUrl);
		}

		/**
		 * Sends AccessoPay Apple Pay availability
		 * @param {Object} event Event payload
		 * @returns {undefined}
		 */
		function _checkForApplePay(event){
			service._sendAccessoPayMessage(event.frameId, Enums.messages.ACCESSO_PAY_APPLE_PAY_AVAILABILITY, { available: ApplePayPreloader.sessionAvailable });
		}

		/**
		 * Send parent window a message with merchant validation payload from Accesso Pay
		 * @param {Object} event Event payload
		 * @returns {undefined}
		 */
		function _completeApplePayMerchantValidation(event){
			service._sendParentMessage(Enums.messages.APPLEPAY_VALIDATE_RESPONSE, { data: event.payload });
		}

		/**
		 * Send parent window a message to complete Apple Pay session
		 * @param {Object} event Event
		 * @returns {undefined}
		 */
		function _completeApplePayPayment(event){
			service._sendParentMessage(Enums.messages.APPLEPAY_PAYMENT_RESPONSE, { status: event.payload });
		}

		/**
		 * Initiates an apple pay session in the parent window with listener
		 * @protected
		 * @param {Object} event Event payload
		 * @returns {undefined}
		 */
		function _initiateParentApplePaySession(event) {
			var applePayVersion,
				frameId,
				paymentRequest,
				postMessages;

			if (!validObject(event)) {
			  return;
			}

			applePayVersion = event.version;
			frameId = event.frameId;
			paymentRequest = event.paymentRequest;
			postMessages = Enums.messages;

			$window.addEventListener('message', function onApplePayMessage(message) {
			  var ApplePaySession = $window.ApplePaySession || {};
			  try {
				var msg = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

				if (!UtilsValidation.isRealObject(msg) || !msg.messageType) {
				  return;
				}

				switch (msg.messageType) {
				  case postMessages.APPLEPAY_VALIDATE_MERCHANT:
					service._sendAccessoPayMessage(frameId, postMessages.ACCESSO_PAY_APPLE_PAY_VALIDATE_MERCHANT, {
					  host: msg.host,
					  validationURL: msg.validationURL
					});
					break;
				  case postMessages.APPLEPAY_SHIPPING_METHOD_SELECTED:
					service._sendParentMessage(postMessages.APPLEPAY_SHIPPING_METHOD_UPDATED, {
					  data: {
						newTotal: paymentRequest.total,
						status: ApplePaySession.STATUS_SUCCESS
					  }
					});
					break;
				  case postMessages.APPLEPAY_SHIPPING_CONTACT_SELECTED:
					// Do nothing
					break;
				  case postMessages.APPLEPAY_AUTHORIZED:
					service._sendAccessoPayMessage(frameId, postMessages.ACCESSO_PAY_APPLE_PAY_AUTHORIZED, {
					  host: msg.host,
					  payment: msg.payment
					});
					$window.removeEventListener('message', onApplePayMessage, false);
					break;
				  case postMessages.APPLEPAY_CANCEL:
					service._sendAccessoPayMessage(frameId, postMessages.ACCESSO_PAY_APPLE_PAY_CANCEL);
					$window.removeEventListener('message', onApplePayMessage, false);
					break;
				}
			  } catch (err) {
				$log.warn(ERROR_PREFIX + err);
				notifyBugsnag(ERROR_PREFIX + 'Apple Pay Message: ' + err);
			  }
			}, false);

			service._sendParentMessage(postMessages.APPLEPAY_START, {
			  version: applePayVersion,
			  paymentRequest: paymentRequest
			});
		  }

		/**
		 * Sends an analytics event about the accesso pay event
		 * @param {Object} evt The accesso Pay event
		 * @returns {undefined}
		 */
		function _sendAnalyticsEvent(evt) {
			AnalyticsDataLayerService.triggerAccessoPayEvent({
				eventName: evt.type,
				eventPayload: checkProp('evt.payload', evt, 'returnValue')
			});
		}

		/**
		 * Destroy accesso Pay instance
		 * @private
		 * @memberof AccessoPayService
		 * @returns {undefined}
		 */
		function _destroyAccessoPayInstance() {
			CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES);
			service.getAccessoPayInstance().destroy();
		}

		/**
		 * Executes on route change
		 * @public
		 * @memberof AccessoPayService
		 * @param {Event} event RouteChanged event
		 * @returns {undefined}
		 */
		function onRouteChanged(event) {
			if (checkProp('event.payload', event, validArray)) {
				currentRoute = event.payload[0].split('?')[0];
				currentRouteParam = event.payload.length === 2 ? event.payload[1].split('?')[0] : '';
				//fire checkout final step analytics event if we have a secondary param
				if (currentRoute === 'select') {
					if (currentRouteParam.length > 0) {
						AccessoPayUtils.broadcastAnalyticsEvent('triggerCheckoutOrderReview', currentRouteParam);
					} else {
						//we landed on the first selection of the route - trigger the checkout billing step
						AccessoPayUtils.broadcastAnalyticsEvent('triggerCheckoutBilling', (UserInfo.get('shipping')||{}).deliveryMethod);
					}
				}
			}
		}

		/**
		 * Returns current selected route in accessoPay
		 * @public
		 * @memberof AccessoPayService
		 * @returns {String} current route
		 */
		function getCurrentRoute() {
			return currentRoute;
		}

		/**
		 * Removes the authorizing route guard
		 * @private
		 * @returns {undefined}
		 */
		function removeAuthorizingRouteGuard() {
			if (angular.isFunction(authorizingRouteGuard)) {
				authorizingRouteGuard();
				authorizingRouteGuard = null;
			}
		}

		/**
		 * Called when we are authorizing.
		 * @returns {undefined}
		 */
		function onAuthorizing() {
			// Remove the old transition if it exists already
			removeAuthorizingRouteGuard();

			notifyBugsnag('authorizing');

			// We need to stop the transition anywhere while we're authorizing so the user doesn't get stray payments
			authorizingRouteGuard = $transitions.onStart({}, function(transition) {
				transition.abort();

				Modal.displayModal({
					action: 'Error',
					buttonFlags: [Enums.buttonFlags.OK],
					category: 'AccessoPay',
					description: getLocale('Billing', 'accessoPayAuthorizingDesc'),
					title: getLocale('Billing', 'accessoPayAuthorizingTitle')
				});
			});
		}

		/**
		 * Executes on delivery selection completed event
		 * @public
		 * @memberof AccessoPayService
		 * @param {Event} event DeliveryInformation event
		 * @returns {undefined}
		 */
		function onDeliveryComplete(event) {
			var shipping = UserInfo.get('shipping'),
				deliveryInfo = event.payload,
				deliveryAddress,
				queryParams = $location.search();

			shipping.deliveryMethod = deliveryInfo.selectedDeliveryId;
			shipping.deliveryAmount = AccessoPayUtils.getDeliveryAmountForSelectedDeliveryMethod(service.getDeliveryMethods(), shipping.deliveryMethod).toString();
			breadcrumb('delivery selected');

			if (checkProp('deliveryInfo.address', deliveryInfo, 'validObject')) {
				deliveryAddress = deliveryInfo.address;
				shipping.isNonPhysicalDeliveryMethod = false;
				shipping.address = deliveryAddress.address1;
				shipping.address2 = deliveryAddress.address2;
				shipping.city = deliveryAddress.city;
				shipping.country = deliveryAddress.country;
				shipping.zip = deliveryAddress.zip;
				shipping.state = deliveryAddress.state;
				shipping.phone = deliveryAddress.phone;
				shipping.firstName = deliveryAddress.firstName;
				shipping.lastName = deliveryAddress.lastName;
				shipping.email = deliveryAddress.email;
			}
			UserInfo.set('shipping', shipping);
			//add for checkout funnel step for delivery
			AccessoPayUtils.broadcastAnalyticsEvent('triggerShippingSelection', deliveryInfo.selectedDeliveryId);

			// We're coming back from a redirect or already executing this request, so we don't want to update the cart
			if (queryParams[Enums.urlParametersAccessoPay.REDIRECT_SESSION_TOKEN] || $rootScope.hasPendingRequest(Enums.services.UPDATE_CART_CHECKOUT_INFO)) {
				return;
			}

			LegacyCart.callUpdateCartCheckoutInfo(
				{
					// eslint-disable-next-line camelcase
					additional_attributes: [{
						name: 'accessoPay',
						value: 'true'
					}, {
						name: 'rawCardBrand',
						value: 'accessoPay'
					}],
					shippingAmount: shipping.deliveryAmount,
					shippingMethod: shipping.deliveryMethod
				},
				angular.noop,
				function handleFailedUpdate() {
					onDeliveryCartSummaryFailed();
				}
			);
		}

		/**
		 * Gets the window object
		 * @public
		 * @memberof AccessoPayService
		 * @returns {Object} The window object
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Executes on cancel event
		 * @public
		 * @memberof AccessoPayService
		 * @returns {undefined}
		 */
		function onCancel() {
			notifyBugsnag('on cancel');
			service._destroyAccessoPayInstance();
			$rootScope.routeTo(Enums.routes.CART);
		}

		/**
		 * Sets the billing demographics when we receive it.
		 * @private
		 * @memberof AccessoPayService
		 * @param {Event<{payload:User}>} evt The billing demographics event
		 * @returns {undefined}
		 */
		function onBillingDemographics(evt) {
			var payload = evt.payload;
			breadcrumb('billing demographics');

			if (angular.isObject(payload)) {
				if (!validString(payload.firstName) || !validString(payload.lastName)) {
					notifyBugsnag('first or last name is empty');
				}

				/* eslint-disable sort-keys */
				UserInfo.set('billing', {
					firstName: payload.firstName,
					lastName: payload.lastName,
					middleInitial: payload.middleInitial,
					phone: payload.phone,
					countryCode: payload.phoneCountryCode,
					email: payload.email,
					address: payload.address1,
					address2: payload.address2,
					city: payload.city,
					country: payload.country,
					state: payload.stateProvince,
					zip: payload.zipPostal
				});
				/* eslint-disable sort-keys */
			} else {
				notifyBugsnag('received non-object payload');
			}
		}

		/**
		 * Executes on initialization failed event
		 * @public
		 * @memberof AccessoPayService
		 * @returns {undefined}
		 */
		function onInitializeFailed(event) {
			var msg = checkProp('event.payload.reason', event, validString) ? event.payload.reason : '';
			service._destroyAccessoPayInstance();
			$rootScope.hideSpinner();
			notifyBugsnag('initialize failed: ' + msg);
			showGenericPurchaseErrorAndRouteToCart();
		}

		/**
		 * Executes when GetCartSummary has item-level failures during Delivery event
		 * @public
         * @returns {undefined}
		 */
		function onDeliveryCartSummaryFailed() {
			service._destroyAccessoPayInstance();
			$rootScope.hideSpinner();
			notifyBugsnag('cartSummary failed during delivery');
			showGenericPurchaseErrorAndRouteToCart();
		}

		/**
		 * Show a generic failure message and route to Cart
		 * @public
		 * @returns {undefined}
		 */
		function showGenericPurchaseErrorAndRouteToCart(){
			Modal.displayModal({
				action: 'Error',
				buttonFlags: [Enums.buttonFlags.OK],
				callback: function() {
					Utilities.goTo(Enums.routes.CART_VIEW);
				},
				category: 'Cart [Purchase]',
				description: getLocale('ErrorCodes', '156'),
				icon: 'icon-info red',
				label: 'Purchase Auth Error',
				sessionId: AppData.cart.session_id,
				showCloseButton: false,
				title: Language.replaceAll('@@errorCode', '156', getLocale('ErrorCodes', 'errorCodeTitle'))
			});
		}

		/**
		 * Wraps a function in a digest cycle.
		 * @public
		 * @memberof AccessoPayService
		 * @param {Function} func The function to wrap in a digest
		 * @throws {TypeError} when param is not a function
		 * @returns {Object} the defaults
		 */
		function createAccessoPayEvent(func) {
			if (!isFunction(func)) {
				throw new TypeError(ERROR_PREFIX + 'createAccessoPayEvent requires a function');
			}

			return function() {
				var args = arguments;

				$rootScope.$apply(function() {
					// eslint-disable-next-line no-invalid-this
					func.apply(this, args);
				});
			};
		}

		/**
		 * Removes query params relating to coming back from a redirect.
		 * @public
		 * @memberof AccessoPayService
		 * @returns {undefined}
		 */
		function clearQueryParams() {
			var queryParams = $location.search(),
				win = service.getWindow(),
				queryParamsToClear = Object
					.values(Enums.urlParametersAccessoPay)
					.concat(['cart_id', 'cart_key', 'session_id', 'access_token', 'guest_checkout']);

			breadcrumb('clear query params');

			if (Utilities.isInIFrame()) {
				win.parent.postMessage(JSON.stringify({
					messageType: Enums.messages.ACCESSO_PAY_CLEAR_QUERY_PARAMS,
					queryParams: queryParamsToClear
				}), '*');
			}

			queryParamsToClear.forEach(function clearQueryParam(value) {
				delete queryParams[value];
			});

			$location.replace();
			$location.search(queryParams);
		}

		/**
		 * handles the donation select event
		 * Donation - we need the name from the accesso pay team
		 * @param {Event} event DonationSelect event
		 * @returns {undefined}
		 */
		function onDonationSelect(event) {
			var donation = event.payload;
			if (donation) {
				UserInfo.set('donation', donation);
			}
		}

		/**
		 * handles the donation select event
		 * Donation - we need the name from the accesso pay team
		 * @param {Event} event DonationSelect event
		 * @returns {undefined}
		 */
		function onDonationDecline(event) {
			UserInfo.set('donation', null);
			var savedPayment = UserInfo.get('payment');
			if (savedPayment && savedPayment.donationAmount) {
				delete savedPayment.donationAmount;
				delete savedPayment.donationStatus;
				delete savedPayment.splitDonation;
				UserInfo.set('payment', savedPayment);
			}
		}

		/**
		 * Returns the CSS variables to use with accesso Pay
		 * @returns {Object} The css variables object
		 */
		function getCssVariables() {
			var theme,
				variables = {},
				documentStyles = window.getComputedStyle(document.documentElement);

			if (JSONValidator.validate('theme', AppData.settings.theme)) {
				theme = JSON.parse(AppData.settings.theme);

				if (validString(theme.spinner)) {
					variables['bar-color'] = documentStyles.getPropertyValue('--gap-' + theme.spinner);
				}
			}

			if (!variables['bar-color']) {
				variables['bar-color'] = documentStyles.getPropertyValue('--gap-tertiary');
			}

			return variables;
		}

		/**
		 * handles the insurance select event
		 * @param {Event} event InsuranceSelect event
		 * @returns {undefined}
		 */
		function onInsuranceSelect(event) {
			var insurance = event.payload;
			if (insurance) {
				UserInfo.set('insurance', insurance);
			}
		}

		/**
		 * handles the insurance select event
		 * @param {Event} event InsuranceDecline event
		 * @returns {undefined}
		 */
		function onInsuranceDecline(event) {
			UserInfo.set('insurance', null);
			var savedPayment = UserInfo.get('payment');
			if (savedPayment && savedPayment.premiumAmount) {
				delete savedPayment.premiumAmount;
				delete savedPayment.insuranceStatus;
				delete savedPayment.splitInsurance;
				UserInfo.set('payment', savedPayment);
			}
		}
	}
}());
